/**
 * Modèle organisationnel DojoOS — Karaté Phase 1 (mock/local).
 * Jeu initial minimal BT-046 — aucun dojo officiel inventé.
 */

import {
  SEED_ADMIN_INSTRUCTOR_ID,
  SEED_STUDENT_DEMO_CHILD_ID,
  SEED_STUDENT_MARCEL_ID,
  seedResponsibleId,
} from "./phase1InitialSeed046.js";

export const KARATE_MAIN_ORGANIZATION = {
  id: "org-shotokan-aamc",
  nom: "Shotokan AAMC — Black Dragon",
  type: "association",
  statut: "demo_a_valider",
  objectifDojos: 10,
  dojosConfirmes: 0,
  dojosDemo: 10,
  messageFr:
    "Organisation principale — jeu initial minimal [DÉMO]. Dix emplacements dojo et responsables à confirmer ; noms réels limités aux personnes fournies.",
  messageEn:
    "Main organization — minimal initial [DEMO] dataset. Ten dojo slots and leads to confirm; real names limited to provided persons.",
};

/** @typedef {'hanshi'|'sensei'|'assistant'|'parent'|'student'} DemoPrimaryRole */

/**
 * Comptes démo locaux — mot de passe : demo
 * @type {Record<string, object>}
 */
export const DEMO_USER_REGISTRY = {
  admin: {
    id: "demo-admin",
    username: "admin",
    password: "demo",
    role: "hanshi",
    nameFr: "Gilles Lavigne",
    nameEn: "Gilles Lavigne",
    instructorId: SEED_ADMIN_INSTRUCTOR_ID,
    dojoId: null,
    accessibleRoles: ["hanshi", "sensei", "assistant", "parent", "student"],
    statut: "actif",
    demo: true,
  },
  sensei: {
    id: "demo-sensei",
    username: "sensei",
    password: "demo",
    role: "sensei",
    nameFr: "Sensei démo [DÉMO]",
    nameEn: "Demo Sensei [DEMO]",
    dojoId: "demo-dojo-01",
    accessibleRoles: ["sensei"],
    statut: "actif",
    demo: true,
  },
  sempai: {
    id: "demo-sempai",
    username: "sempai",
    password: "demo",
    role: "assistant",
    nameFr: "Responsable 1 — à confirmer",
    nameEn: "Responsible 1 — to confirm",
    instructorId: seedResponsibleId(1),
    dojoId: "demo-dojo-01",
    accessibleRoles: ["assistant"],
    statut: "actif",
    demo: true,
  },
  parent: {
    id: "demo-parent",
    username: "parent",
    password: "demo",
    role: "parent",
    nameFr: "Parent démo [DÉMO]",
    nameEn: "Demo Parent [DEMO]",
    dojoId: "demo-dojo-01",
    childStudentIds: [SEED_STUDENT_DEMO_CHILD_ID],
    accessibleRoles: ["parent"],
    statut: "actif",
    demo: true,
  },
  etudiant: {
    id: "demo-etudiant",
    username: "etudiant",
    password: "demo",
    role: "student",
    nameFr: "Marcel Charette",
    nameEn: "Marcel Charette",
    dojoId: "demo-dojo-01",
    studentId: SEED_STUDENT_MARCEL_ID,
    senseiId: "demo-sensei-placeholder",
    accessibleRoles: ["student"],
    statut: "actif",
    demo: true,
  },
};

/** @deprecated use DEMO_USER_REGISTRY */
export const DEMO_USERS = Object.fromEntries(
  Object.entries(DEMO_USER_REGISTRY).map(([k, u]) => [
    k,
    { username: u.username, password: u.password, role: u.role, name: u.nameFr },
  ]),
);

export const DEMO_ACCOUNTS_ADMIN = Object.values(DEMO_USER_REGISTRY).map((u) => ({
  id: u.id,
  username: u.username,
  name: u.nameFr,
  nameEn: u.nameEn,
  role: u.role,
  accessibleRoles: u.accessibleRoles,
  dojoId: u.dojoId,
  statut: u.statut,
  demo: true,
}));

export const SEED_ACCOUNT_REQUESTS = [
  {
    id: "req-seed-etudiant",
    name: "[DÉMO] Alex Tremblay",
    email: "alex.demo@example.local",
    phone: "",
    role: "student",
    organization: "[DÉMO] Emplacement dojo 1",
    childName: "",
    message: "Inscription cours adultes — démo locale.",
    status: "a_valider",
    createdAt: "2026-01-15T10:00:00.000Z",
    demo: true,
  },
  {
    id: "req-seed-parent",
    name: "[DÉMO] Marie Parent",
    email: "marie.demo@example.local",
    phone: "514-000-0000",
    role: "parent",
    organization: "[DÉMO] Emplacement dojo 1",
    childName: "[DÉMO] Enfant exemple",
    message: "Accès parent pour suivi enfant — démo.",
    status: "a_valider",
    createdAt: "2026-01-16T14:30:00.000Z",
    demo: true,
  },
  {
    id: "req-seed-sensei",
    name: "[DÉMO] Jean Instructeur",
    email: "jean.demo@example.local",
    role: "sensei",
    organization: "Nouveau dojo — à confirmer",
    message: "Demande accès Sensei — validation Hanshi requise.",
    status: "a_valider",
    createdAt: "2026-01-17T09:00:00.000Z",
    demo: true,
  },
  {
    id: "req-seed-sempai",
    name: "[DÉMO] Kim Assistant",
    email: "kim.demo@example.local",
    role: "assistant",
    organization: "[DÉMO] Emplacement dojo 1",
    message: "Demande rôle Sempai / assistant — démo.",
    status: "a_valider",
    createdAt: "2026-01-18T11:00:00.000Z",
    demo: true,
  },
];

/** Rôles affichés dans le switcher admin (dropdown BT-013). */
export const ADMIN_SWITCHER_ROLES = [
  { id: "hanshi", labelFr: "Hanshi/Admin", labelEn: "Hanshi/Admin", icon: "🐉" },
  { id: "sensei", labelFr: "Sensei", labelEn: "Sensei", icon: "🥋" },
  { id: "assistant", labelFr: "Sempai / assistant", labelEn: "Sempai / assistant", icon: "🤝" },
  { id: "parent", labelFr: "Parent", labelEn: "Parent", icon: "👨‍👩‍👧" },
  { id: "student", labelFr: "Étudiant", labelEn: "Student", icon: "🎓" },
];

/**
 * @param {string} username
 * @param {'fr'|'en'} [locale]
 */
export function getDemoUserDisplayName(username, locale = "fr") {
  const u = DEMO_USER_REGISTRY[username];
  if (!u) return username;
  return locale === "en" ? u.nameEn : u.nameFr;
}

/**
 * @param {string} primaryRole
 */
export function getDefaultRouteForRole(primaryRole) {
  const map = {
    hanshi: "/accueil",
    admin: "/accueil",
    sensei: "/accueil",
    assistant: "/accueil",
    parent: "/accueil",
    student: "/accueil",
  };
  return map[primaryRole] || "/accueil";
}

/**
 * @param {string} username
 */
export function getDemoContextForAccount(username) {
  const u = DEMO_USER_REGISTRY[String(username || "").toLowerCase()];
  if (!u) return null;
  return {
    dojoId: u.dojoId,
    childStudentIds: u.childStudentIds || [],
    studentId: u.studentId || null,
    senseiId: u.senseiId || null,
    accessibleRoles: u.accessibleRoles,
  };
}
